import { useState, useEffect } from "react";

interface VisibilityState {
  [key: string]: boolean;
}

/**
 * Custom hook for fade-in animations on scroll
 * Uses Intersection Observer API to track when sections become visible
 */
const useScrollAnimation = (): VisibilityState => {
  const [isVisible, setIsVisible] = useState<VisibilityState>({
    "how-it-works": false,
    features: false,
    "target-users": false,
    "use-cases": false,
    faq: false,
    "bottom-cta": false,
  });

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible((prev) => ({ ...prev, [entry.target.id]: true }));
          }
        });
      },
      { threshold: 0.1 }
    );

    const sections = document.querySelectorAll("section[id]");
    sections.forEach((section) => observer.observe(section));

    return () => sections.forEach((section) => observer.unobserve(section));
  }, []);

  return isVisible;
};

export default useScrollAnimation;
